import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

const PrivateRoutes = () => {
  const {isAuthenticated} = useAuth();
  return isAuthenticated ? <Outlet /> : <Navigate to="/flexp-login" />
}

export default PrivateRoutes;
